webpackJsonp([41579278739242],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0px 0px 40px;\n'], ['\n  margin: 0px 0px 40px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-weight: 400;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n  letter-spacing: 0.25px;\n'], ['\n  font-weight: 400;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n  letter-spacing: 0.25px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n  opacity: 0.5;\n  padding-left: 0.5rem;\n'], ['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n  opacity: 0.5;\n  padding-left: 0.5rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  margin: 0px 0px .5rem;\n  opacity: 1;\n  ', '\n  font-weight: 300;\n  letter-spacing: 0.25px;\n'], ['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  margin: 0px 0px .5rem;\n  opacity: 1;\n  ', '\n  font-weight: 300;\n  letter-spacing: 0.25px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 10px 20px;\n  margin: 10px 0px;\n  color: steelblue;\n  border-left: 5px solid steelblue;\n\n  & p {\n    margin-bottom: 0.25rem;\n  }\n\n  & a {\n    color: #333;\n    opacity: 0.8;\n  }\n'], ['\n  padding: 10px 20px;\n  margin: 10px 0px;\n  color: steelblue;\n  border-left: 5px solid steelblue;\n\n  & p {\n    margin-bottom: 0.25rem;\n  }\n\n  & a {\n    color: #333;\n    opacity: 0.8;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _Card = __webpack_require__(30);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var Research_Item = function Research_Item(props) {
	  return _react2.default.createElement(
	    ProjectCard,
	    null,
	    _react2.default.createElement(
	      ProjectTitle,
	      null,
	      props.proj.title,
	      _react2.default.createElement(
	        ProjectInstitution,
	        null,
	        '(',
	        props.proj.institution,
	        ')'
	      )
	    ),
	    _react2.default.createElement(ProjectDescription, {
	      dangerouslySetInnerHTML: { __html: marked(props.proj.description.description, { sanitize: true }) } }),
	    props.proj.relavantPapers && _react2.default.createElement(
	      'h4',
	      { style: { margin: '1.5rem 0', fontSize: '1.1rem', fontWeight: '400' } },
	      'Relevant Papers'
	    ),
	    props.proj.relavantPapers && props.proj.relavantPapers.map(function (paper, i) {
	      console.log(paper);
	      return _react2.default.createElement(
	        RelevantPapers,
	        { key: i },
	        _react2.default.createElement(
	          'p',
	          null,
	          paper.title
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: paper.abstractUrl, target: '_blank' },
	          paper.doiNumber
	        )
	      );
	    })
	  );
	};
	
	exports.default = Research_Item;
	
	
	var ProjectCard = _Card2.default.extend(_templateObject);
	
	var ProjectTitle = _styledComponents2.default.h2(_templateObject2);
	
	var ProjectInstitution = _styledComponents2.default.span(_templateObject3);
	
	var ProjectDescription = _styledComponents2.default.p(_templateObject4, '' /* font-family: Open Sans; */);
	
	var RelevantPapers = _Card2.default.extend(_templateObject5);
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  line-height: 1.75rem;\n  font-size: 1.25rem;\n  font-weight: 300;\n  ', '\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 20px;\n  }\n'], ['\n  line-height: 1.75rem;\n  font-size: 1.25rem;\n  font-weight: 300;\n  ', '\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 20px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionText = _styledComponents2.default.div(_templateObject, '' /* opacity: 0.9; */);
	
	exports.default = SectionText;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Research_Item = __webpack_require__(201);
	
	var _Research_Item2 = _interopRequireDefault(_Research_Item);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _SectionText = __webpack_require__(45);
	
	var _SectionText2 = _interopRequireDefault(_SectionText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var ResearchPage = function ResearchPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { minHeight: '100vh' } },
	    _react2.default.createElement(
	      _Container2.default,
	      { research: true },
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        { light: true },
	        _react2.default.createElement(
	          _SectionHeader2.default,
	          { light: true },
	          'Research'
	        ),
	        _react2.default.createElement(_SectionText2.default, { dangerouslySetInnerHTML: { __html: marked(data.allContentfulPage.edges[0].node.mainText.body.body, { sanitize: true }) }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        null,
	        _react2.default.createElement(
	          _SectionHeader2.default,
	          null,
	          'Current Projects'
	        )
	      ),
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        null,
	        data.allContentfulPage.edges[0].node.featuredItems && data.allContentfulPage.edges[0].node.featuredItems.map(function (item, i) {
	          return _react2.default.createElement(_Research_Item2.default, { key: i, proj: item, i: i });
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      { grey: true },
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        null,
	        _react2.default.createElement(
	          _SectionHeader2.default,
	          null,
	          'Previous Projects'
	        )
	      ),
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        null,
	        data.allContentfulPage.edges[0].node.additionalItems && data.allContentfulPage.edges[0].node.additionalItems.map(function (item, i) {
	          return _react2.default.createElement(_Research_Item2.default, { key: i, proj: item, i: i });
	        })
	      )
	    )
	  );
	};
	
	exports.default = ResearchPage;
	var query = exports.query = '** extracted graphql fragment **';
	
	// const Container = styled.div`
	//   background-color: #eee;
	//   flex-direction: column;
	//   justify-content: center;
	//   padding: 40px 10px;
	//   min-height: 100vh;
	//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
	// `;
	//
	// const InnerContainer = styled.div`
	//   max-width: 960px;
	//   margin: auto;
	//   padding: 20px;
	//   color: #333;
	// `;
	//
	// const SectionHeader = styled.h1`
	//   text-align: center;
	//   font-weight: 300;
	// `;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-research-js-55633dab5cd130e472f2.js